(function(){
    'use strict'; 
    angular.module('Directives').directive('bbaAccountingNotesList', bbaAccountingNotesList); 
    bbaAccountingNotesList.$inject = [];

    /**
     * @directive   bbaAccountingNotesList
     * @description Generate notes list panel
     * 
     */
    function bbaAccountingNotesList(){
        return {
            restrict: 'E', 
            templateUrl: '/templates/directives/components/accounting/bbaAccountingNotesList.html', 
            scope: {
                label: '=',
                data:  '=',
                isViewMode: '='
            }, 
            link: bbaAccountingNotesListLink
        }

        function bbaAccountingNotesListLink($scope, $attrs, $elems) {
            $scope.notesFields = [];

            $scope.addNewNote = addNewNote; 
            $scope.cancel     = cancel; 
            $scope.save       = save; 
            $scope.edit       = edit;
            $scope.remove     = remove;

            init();

            /**
             * @function    init
             * @description Initialize all the methods that needed to be run whend the directive is called 
             * 
             */
            function init(){
                initializeNotes();
            }

            /**
             * @function    initializeNotes
             * @description Initialize notes data
             * 
             */
            function initializeNotes(){
                $scope.$watch('data', (data) => {
                    if(data) {
                        if($scope.data.length == 0) {
                            $scope.notesFields = [{
                                message: '', 
                                disabled: false, 
                                hasError: false
                            }];
                        } else {
                            $scope.notesFields = [];
                            $scope.data.forEach(notes=>{
                                $scope.notesFields.push({
                                    message: notes, 
                                    disabled: true, 
                                    hasError: false
                                });
                            });
                        }
                    }
                });
            }

            /**
             * @function    addNewNote
             * @description Add new notes on the list
             * 
             */
            function addNewNote(){
                $scope.notesFields.push({
                    message: "", 
                    disabled: false,
                    hasError: false
                });
            }

            /**
             * @function    save
             * @description Save notes list data
             * 
             * @param       { Object } field 
             * @param       { int } index 
             */
            function save(field, index){
                if(field.message != "") {
                    field.disabled = true;
                    field.hasError = false;

                    if($scope.data[index] === undefined) {
                        $scope.data.push(field.message);
                    } else {
                        $scope.data[index] = field.message;
                    }
                }
                else {
                    field.hasError = true;
                }
            }

            /**
             * @function    cancel  
             * @description Cancel notes edit
             * 
             * @param       { Object } field 
             * @param       { index } index 
             */
            function cancel(field, index) {
                if(field.message) {
                    field.disabled = true;
                }  
                else {
                    $scope.notesFields.splice(index, 1);
                }
            }

            /**
             * @function    edit
             * @description Edit selected notes data
             * 
             * @param       { Object } field 
             */
            function edit(field){
                field.disabled = false;
            }

            /**
             * @function    remove
             * @description Remove selected notes from the field.
             * 
             * @param       { int } index 
             */
            function remove(index){
                $scope.notesFields.splice(index, 1);
                $scope.data = $scope.notesFields.map(note => {
                    return note.message;
                });
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/accounting/bbaAccountingNotesList.js